<template>
  <div class="main">
    <my_menu></my_menu>

    <div class="content">
      <div class="table_box">
        <Spin fix size="large" v-if="table_loading"></Spin>

        <div v-for="(item, i) in dep_list" :key="i" class="dep_list">
          <div class="team_title" @click="click_copy(item.value)">
            {{ item.label }}（财务编码:{{ item.caiwu_code }}）
          </div>
          <div class="children_box">
            <div
              class="children_dep"
              v-for="(children_item, children_index) in item.children"
              :key="children_index"
              @click="click_editor(children_item)"
            >
              {{ children_item.label }}（财务编码:{{ children_item.caiwu_code }}）
            </div>
            <div class="children_dep2" @click="add_team(item)">
              <Icon type="md-add" />添加小组
            </div>
          </div>
        </div>
      </div>
    </div>

    <Modal
      v-model="add_show"
      title="添加部门"
      :mask-closable="false"
      :footer-hide="true"
      width="400"
    >
      <Input v-model="add_item.name" placeholder="输入部门名称" style="width: 300px" />
      <div class="add_btn_div">
        <Button type="primary" @click="add_dep_http">确认添加</Button>
      </div>
    </Modal>

    <Modal
      v-model="editor_show"
      title="编辑部门"
      :mask-closable="false"
      :footer-hide="true"
      width="400"
    >
      <div class="update_team_div">
        {{ update_item.dep_id }}
      </div>
      <Input v-model="update_item.name" placeholder="输入部门名称" style="width: 300px" />
      <div class="add_btn_div">
        <Button type="warning" style="margin-right: 10px" @click="payment_auth"
          >部门发薪主管</Button
        >
        <Button type="error" style="margin-right: 10px" @click="del_http">删除</Button>
        <Button type="primary" @click="update_http">确认更新</Button>
      </div>
    </Modal>

    <Drawer title="审核人员列表" :closable="true" v-model="audit_user_show">
      <div v-for="(item, i) in audit_user_list" :key="i" class="audit_user_card">
        {{ item.name }}
      </div>
    </Drawer>
  </div>
</template>

<script>
import my_menu from "@/component/menu/menu.vue";
import { http } from "@/utils/http.js";

export default {
  components: {
    my_menu,
  },
  data() {
    return {
      windowWidth: document.documentElement.clientWidth, //实时屏幕宽度
      windowHeight: document.documentElement.clientHeight, //实时屏幕高度
      dep_list: [],
      table_loading: false,
      add_show: false,
      add_item: {
        name: "",
        team_id: "",
      },
      editor_show: false,
      update_item: {
        dep_id: "",
        name: "",
      },

      audit_user_show: false,
      audit_user_list: [],
    };
  },

  mounted() {
    this.window_change();
    this.get_dep_list();
  },

  methods: {
    payment_auth() {
      var that = this;
      var obj = {
        dep_id: this.update_item.dep_id,
      };
      http(
        "post",
        process.env.VUE_APP_HOST + "/project_manage/dep/dep_payment_auth",
        obj,
        true
      )
        .then((res) => {
          if (res.code == 0) {
            that.audit_user_list = res.data.auth_name_list;
            that.audit_user_show = true;
            that.editor_show=false
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_editor(item) {
      this.update_item.dep_id = item.value;
      this.update_item.name = item.label;
      this.editor_show = true;
    },

    del_http() {
      var that = this;
      var obj = {
        dep_id: this.update_item.dep_id,
      };
      http("post", process.env.VUE_APP_HOST + "/project_manage/dep/del_dep", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.editor_show = false;
            that.get_dep_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    update_http() {
      var that = this;
      if (this.update_item.name == "") {
        this.$Message.error("请输入名称");
        return;
      }

      var obj = {
        name: this.update_item.name,
        dep_id: this.update_item.dep_id,
      };
      http("post", process.env.VUE_APP_HOST + "/project_manage/dep/update_dep", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.editor_show = false;
            that.get_dep_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    add_team(item) {
      console.log(item);
      this.add_show = true;
      this.add_item.team_id = item.value;
    },

    add_dep_http() {
      var that = this;
      if (this.add_item.name == "") {
        this.$Message.error("请输入名称");
        return;
      }

      var obj = {
        name: this.add_item.name,
        team_id: this.add_item.team_id,
      };
      http("post", process.env.VUE_APP_HOST + "/project_manage/dep/add_dep", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.$Message.success({
              content: res.msg,
              duration: 3,
            });
            that.add_show = false;
            that.get_dep_list();
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    get_dep_list() {
      var that = this;
      var obj = {};
      http("post", process.env.VUE_APP_HOST + "/project_manage/dep/dep_list", obj, true)
        .then((res) => {
          if (res.code == 0) {
            that.dep_list = res.data.dep_list;
          } else {
            that.$Message.error({
              content: res.msg,
              duration: 3,
            });
          }
        })
        .catch((res) => {
          console.log(res, "请求出错");
        });
    },

    click_copy(str) {
      this.$Copy({
        text: str,
      });
    },

    window_change() {
      var that = this;
      // <!--把window.onresize事件挂在到mounted函数上-->
      window.onresize = () => {
        return (() => {
          window.fullHeight = document.documentElement.clientHeight;
          window.fullWidth = document.documentElement.clientWidth;
          that.windowHeight = window.fullHeight; // 高
          that.windowWidth = window.fullWidth; // 宽
        })();
      };
    },
  },
};
</script>

<style scoped>
.audit_user_card{
    padding:10px;
    border:1px solid #ccc;
    border-radius: 5px;
    margin-bottom:5px;
}

.update_team_div {
  padding: 10px;
  color: #ccc;
}

.add_btn_div {
  padding-top: 10px;
  display: flex;
  justify-content: flex-end;
}

.team_title {
  font-size: 14px;
  color: #333;
  font-weight: 600;
  margin-bottom: 10px;
  cursor: pointer;
}

.children_dep {
  margin: 10px;
  border: 1px solid #ccc;
  color: #666;
  padding: 3px 8px;
  font-size: 13px;
  cursor: pointer;

  border-radius: 3px;
}

.children_dep2 {
  margin: 10px;
  border: 1px solid #ccc;
  color: #f9f9f9;
  background: #357bd2;
  display: flex;
  align-items: center;
  padding: 3px 8px;
  font-size: 12px;
  border-radius: 3px;
  cursor: pointer;
}

.children_dep2:hover {
  background-color: #0466dd;
  color: #fff;
}

.children_box {
  display: flex;
  flex-wrap: wrap;
}

.dep_list {
  margin: 10px;
  padding: 5px 10px;
  border-bottom: 1px solid #ececec;
}

.content_page {
  display: flex;
  justify-content: center;
  padding-top: 10px;
}

/deep/ .ivu-tabs-bar {
  margin-bottom: 10px;
}

.circular {
  width: 25px;
  height: 25px;
}

.table_box {
  position: relative;
}

.add_sys_button {
  margin-top: 20px;
  text-align: right;
}

.form_item_title {
  flex-shrink: 0;
  width: 100px;
}

.form_item {
  display: flex;
  align-items: center;
}

.options {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 10px;
}

.content {
  width: calc(100% - 180px);
  background-color: #fff;
  position: absolute;
  right: 0px;
  top: 0px;
  height: 100vh;
  padding: 10px;
}

.main {
  background: #f5f7f9;
  min-height: 100vh;
}
</style>
